import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7d0bf61c&scoped=true&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./index.vue?vue&type=style&index=0&id=7d0bf61c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d0bf61c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zfh/dev/targus-micor/targus-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d0bf61c')) {
      api.createRecord('7d0bf61c', component.options)
    } else {
      api.reload('7d0bf61c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7d0bf61c&scoped=true&", function () {
      api.rerender('7d0bf61c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/component/userAvatar/index.vue"
export default component.exports